"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSupportDocsURL = exports.getSupportDocsBaseURL = void 0;
const LOCALE_URL_PREFIX_MAP = new Map([
    ["de-DE", "de"],
    ["en-AU", "en-au"],
    ["en-CA", "en-ca"],
    ["en-GB", "en-gb"],
    ["es", "es"],
    ["es-ES", "es-es"],
    ["fr-CA", "fr-ca"],
    ["fr-FR", "fr"],
    ["ja-JP", "ja-jp"],
    ["pt-BR", "pt-br"],
    ["zh-SG", "zh-sg"],
]);
function getSupportDocsBaseURL(locale) {
    const prefix = LOCALE_URL_PREFIX_MAP.get(locale);
    return prefix
        ? `https://${prefix}.support.procore.com`
        : "https://support.procore.com";
}
exports.getSupportDocsBaseURL = getSupportDocsBaseURL;
function generateSupportDocsURL(url, locale) {
    const baseURL = getSupportDocsBaseURL(locale);
    try {
        const parsed = new URL(url);
        return `${baseURL}${parsed.pathname}${parsed.search}`;
    }
    catch (_a) {
        console.error(`Failed to parse URL: ${url}`);
    }
    return url.startsWith("/") ? `${baseURL}${url}` : `${baseURL}/${url}`;
}
exports.generateSupportDocsURL = generateSupportDocsURL;
//# sourceMappingURL=GenerateSupportDocsURL.js.map